/**
 * Formats cents with the shop's own money format, so prices painted by
 * script match the ones Liquid rendered (CA$, €, and so on).
 */
(function () {
  'use strict';

  var fallback = '${{amount}}';

  function groups(n, decimals, thousands, point) {
    var fixed = (n / 100).toFixed(decimals);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.join(point);
  }

  window.novaMoney = function (cents, format) {
    format = format || window.novaMoneyFormat || fallback;
    cents = Number(cents) || 0;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return groups(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return groups(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return groups(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return groups(cents, 2, "'", '.');
        default: return groups(cents, 2, ',', '.');
      }
    });
  };
})();
